<template>
  <v-dialog
    v-bind="$attrs"
    v-on="$listeners"
    @input="close"
    @keydown.esc="close"
  >
    <v-card>
      <v-card-title
        v-if="is_show_title"
        :class="$style.titleBox"
      >
        <h2
          :class="[
            { [$style.titleCentered]: center_title },
            'text-h2', $style.title
          ]"
        >
          <slot name="title" />
        </h2>
        <v-btn
          icon
          small
          color="primary darken-3"
          @click="close"
          absolute
          :class="$style.btnClose"
        >
          <v-icon>
            mdi-close
          </v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text
        v-if="is_show_text"
        :class="[
          { [$style.textCentered]: center_text },
          text_block_classes,
          $style.text,
          'text-body-1 pl-4 pr-4 pb-0 mb-4'
        ]"
      >
        <slot name="text" />
      </v-card-text>
      <v-card-actions
        :class="[
          $style.modalButtons,
          $style[bts_align],
        ]"
      >
        <slot
          name="actions"
          v-if="!hide_actions_btns"
        >
          <v-btn
            :class="$style.closeSuccessDialog"
            color="accent darken-4"
            depressed
            @click="close"
          >
            <slot name="button-text">
              Завершить
            </slot>
          </v-btn>
        </slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import {
  Component,
  Emit,
  Prop,
  Vue,
} from 'vue-property-decorator';
import { BtnsPosition } from './types';

@Component
export default class SimpleDialog extends Vue {
  @Prop({ type: Boolean, default: false })
  center_title!: boolean;

  @Prop({ type: Boolean, default: false })
  center_text!: boolean;

  @Prop({ type: String, default: BtnsPosition.START })
  bts_align!: BtnsPosition;

  @Prop({ type: Boolean, default: false })
  hide_actions_btns?: boolean;

  @Emit()
  close() {
    return false;
  }

  get is_show_title() {
    return 'title' in this.$scopedSlots;
  }

  get is_show_text() {
    return 'text' in this.$scopedSlots;
  }

  get text_block_classes() {
    return !this.is_show_title ? 'pt-4' : 'mt-4';
  }
}
</script>

<style module lang="scss">
@import '../common.scss';

.titleCentered {
  margin-left: auto;
  margin-right: auto;
}

.textCentered {
  text-align: center;
}

.titleBox {
  justify-content: space-between;
  padding-bottom: 8px;
  padding-left: 16px;
  padding-right: 16px;
  position: relative;
}

.btnClose {
  right: 0;
  top: 0;
  transform: translate(-50%, 50%);
}
@media (max-width: 599px) {
  .btnClose {
    transform: none;
  }
}

.title {
  padding-right: 20px;
  padding-left: 20px;
}

.text {
  color: $primary_darken1 !important;
}
</style>
